var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11686_1451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.61125 24.4443H6.05542C6.66896 24.4443 7.16667 24.9414 7.16667 25.5551V36.6663C7.16667 37.2799 6.66906 37.7776 6.05542 37.7776H1.61125C0.997708 37.7776 0.5 37.28 0.5 36.6663V25.5551C0.5 24.9416 0.997604 24.4443 1.61125 24.4443ZM12.7221 15.5551H17.1667C17.7802 15.5551 18.2779 16.0527 18.2779 16.6663V36.6663C18.2779 37.2799 17.7803 37.7776 17.1667 37.7776H12.7221C12.1085 37.7776 11.6112 37.28 11.6112 36.6663V16.6663C11.6112 16.0528 12.1084 15.5551 12.7221 15.5551ZM23.8333 19.9997H28.2779C28.8915 19.9997 29.3888 20.4973 29.3888 21.1109V36.6663C29.3888 37.2799 28.8916 37.7776 28.2779 37.7776H23.8333C23.2198 37.7776 22.7221 37.28 22.7221 36.6663V21.1109C22.7221 20.4974 23.2197 19.9997 23.8333 19.9997ZM34.9446 13.333H39.3887C40.0023 13.333 40.5 13.8306 40.5 14.4443V36.6663C40.5 37.2799 40.0024 37.7776 39.3887 37.7776H34.9446C34.331 37.7776 33.8333 37.28 33.8333 36.6663V14.4443C33.8333 13.8307 34.3309 13.333 34.9446 13.333Z",
    fill: "url(#paint0_linear_11686_1451)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1667 0C35.3267 0.00208333 33.8354 1.49333 33.8333 3.33333C33.8378 3.69625 33.9021 4.05604 34.0238 4.39781L28.4615 7.70417C28.1016 7.32249 27.656 7.03197 27.1616 6.85662C26.6672 6.68126 26.1381 6.62612 25.6182 6.69574C25.0983 6.76536 24.6024 6.95775 24.1715 7.257C23.7406 7.55625 23.3872 7.95376 23.1404 8.41667L18.2344 5.98677C18.2583 5.84396 18.2726 5.6999 18.2779 5.55542C18.2792 4.89568 18.0846 4.25041 17.7189 3.70131C17.3532 3.15221 16.8328 2.72398 16.2236 2.47084C15.6143 2.2177 14.9437 2.15105 14.2965 2.27931C13.6494 2.40757 13.0549 2.72498 12.5882 3.19135C12.1215 3.65762 11.8036 4.25194 11.675 4.89902C11.5463 5.54609 11.6126 6.21679 11.8655 6.82615L5.50167 11.5755C4.9969 11.2748 4.42089 11.1145 3.83333 11.1113C1.9925 11.1113 0.5 12.6033 0.5 14.4446C0.5 16.2854 1.9925 17.7779 3.83333 17.7779C5.67417 17.7779 7.16667 16.2854 7.16667 14.4446C7.16383 14.0436 7.08812 13.6466 6.94323 13.2727L13.3707 8.47583C14.628 9.17688 16.1962 8.97135 17.2301 7.96958L22.8092 10.7328C23.181 12.3894 24.7399 13.5009 26.4273 13.313C28.1148 13.125 29.3908 11.698 29.3888 10C29.3888 9.91531 29.37 9.83563 29.364 9.7526L35.4137 6.15604C35.9384 6.48771 36.546 6.66469 37.1667 6.66667C39.0075 6.66667 40.5 5.17417 40.5 3.33333C40.5 1.4925 39.0075 0 37.1667 0Z",
    fill: "url(#paint1_linear_11686_1451)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11686_1451",
    x1: 5.52533,
    y1: 13.8122,
    x2: 27.9746,
    y2: 42.4519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83DEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17ADF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11686_1451",
    x1: 5.52533,
    y1: 0.348522,
    x2: 19.9932,
    y2: 25.7274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83DEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17ADF6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11686_1451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytic);
export default __webpack_public_path__ + "static/media/analytic.8c8970796e508985f5a1b5df801b61ad.svg";
export { ForwardRef as ReactComponent };